export const environment = {
  production: true,

  name: 'prod',
  /** Activate Logs */
  log: 'true',
  googleClientId: '760897290989-oul885aqa4dulim0q0brt2kp2g9uavn8.apps.googleusercontent.com',
  facebookCleintId: '754160515150594',
  /*  googleClientId: process.env.GOOGLE_CLIENTID,
    facebookCleintId: process.env.FACEBOOK_CLIENTID,
    */
  phones_api_url: 'https://singmeup.herokuapp.com/api/phones',
  phones_api_backend_type: 'node',
};
